export const DataLayerConfig = Object({
  sellLandingPageLoad: {
    eventName: 'Sell Landing PageView',
    pageName: 'Sell Landing',
    pageType: 'Sell Landing',
    siteSection: 'Sell',
    stack: 'Slam',
    appInteraction: 'Sell Landing PageView'
  },
  searchResultsPageLoad: {
    eventName: 'Sell Search Results PageView',
    pageName: 'Sell Search Results',
    pageType: 'Search Results',
    siteSection: 'Sell',
    stack: 'Slam',
    appInteraction: 'Search Results PageView'
  },
  sellTicketPageLoad: {
    eventName: 'SP Sell Landing Pageview',
    pageName: 'SP Sell Landing',
    pageType: 'SP Sell Landing',
    siteSection: 'Sell',
    stack: 'Slam',
    appInteraction: 'Sell Ticket: Listing Creation PageView'
  },
  listingDenied: {
    eventName: 'SP Sell Listing Denied Pageview',
    pageName: 'SP Sell Listing Denied',
    pageType: 'SP Sell Listing Denied',
    siteSection: 'Sell',
    stack: 'Slam',
    appInteraction: 'Sell Ticket: Listing Denied PageView'
  },
  sellTicketDetails: {
    eventName: 'SP Sell Ticket Details Pageview',
    pageName: 'SP Sell Ticket',
    pageType: 'SP Sell Ticket',
    siteSection: 'Sell',
    stack: 'Slam',
    appInteraction: 'Sell Ticket: Ticket Details PageView'
  },
  sellerFrameworkPageLoad: {
    eventName: 'SP Seller Framework Pageview',
    pageName: 'SP Seller Framework',
    pageType: 'SP Seller Framework',
    siteSection: 'Sell',
    stack: 'Slam',
    appInteraction: 'Sell Ticket: Seller Framework PageView'
  },
  sellEventsLoad: {
    eventName: 'SP Sell Landing Pageview',
    pageName: 'SP Sell Flow : Multi Event',
    pageType: 'SP Sell Flow : Multi Event',
    siteSection: 'Sell',
    stack: 'Slam',
    appInteraction: 'Sell Ticket: Listing Creation PageView'
  }
});

export const DataLayerConfigListingConfirmation = {
  eventName: 'SP Sell Listing Confirmation Pageview',
  pageName: 'SP Sell Listing Confirmation',
  pageType: 'SP Sell Listing Confirmation',
  siteSection: 'Sell',
  stack: 'Slam',
  appInteraction: 'Sell Ticket: Listing Success PageView'
};

export const DataLayerConfigListingConfirmationMulti = {
  ...DataLayerConfigListingConfirmation,
  pageName: 'SP Sell Listing Confirmation : Multi Event',
  pageType: 'SP Sell Listing Confirmation : Multi Event'
};
